/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Confirm_Regenerate_WebhookInputs */

const cs_automation_confirm_regenerate_webhook = /** @type {(inputs: Automation_Confirm_Regenerate_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat nový webhook token? Integrace se starou URL přestanou fungovat.`)
};

const en_automation_confirm_regenerate_webhook = /** @type {(inputs: Automation_Confirm_Regenerate_WebhookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate the webhook token? Existing integrations using the old URL will stop working.`)
};

/**
* | output |
* | --- |
* | "Regenerate the webhook token? Existing integrations using the old URL will stop working." |
*
* @param {Automation_Confirm_Regenerate_WebhookInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_confirm_regenerate_webhook = /** @type {((inputs?: Automation_Confirm_Regenerate_WebhookInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Confirm_Regenerate_WebhookInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_confirm_regenerate_webhook(inputs)
	return cs_automation_confirm_regenerate_webhook(inputs)
});